export default "__VITE_ASSET__BubJ2zAw__"